export const ALEXA_APP_LINKING_ROUTE = '/settings/app-to-app-alexa';

/**
 * Normalise a native `go_to_alexa` argument into a query string without `?`.
 */
export function normalizeAlexaQuery(params: unknown): string {
	if (params == null || params === '') {
		return '';
	}

	if (typeof params === 'string') {
		return params.replace(/^\?+/, '').trim();
	}

	if (typeof params === 'object') {
		return new URLSearchParams(
			Object.entries(params as Record<string, unknown>).reduce<Record<string, string>>(
				(acc, [key, value]) => {
					if (value != null) {
						acc[key] = String(value);
					}
					return acc;
				},
				{},
			),
		).toString();
	}

	return String(params).replace(/^\?+/, '').trim();
}

export function buildAlexaAppLinkingHref(query: unknown): string {
	const qs = normalizeAlexaQuery(query);
	return qs ? `${ALEXA_APP_LINKING_ROUTE}?${qs}` : ALEXA_APP_LINKING_ROUTE;
}

export function isAlexaAppLinkingPath(path: string | undefined | null): boolean {
	return typeof path === 'string' && path.includes('app-to-app-alexa');
}

/**
 * Landing (`/`) must not replace an in-flight Alexa deep link: Android can
 * call `go_to_alexa` before `$location` has caught up with the hash.
 */
export function shouldPreserveAlexaDeepLink(
	currentLocation: string,
	pendingQuery: string | null,
	hash: string = '',
): boolean {
	if (pendingQuery !== null) {
		return true;
	}

	return isAlexaAppLinkingPath(hash) || isAlexaAppLinkingPath(currentLocation);
}

/**
 * Integrations card uses `/settings/integrations/app-to-app-alexa`. Rewrite
 * to the real route and keep any query params (code / client_id).
 */
export function rewriteIntegrationsAlexaHref(route: string, currentQuery: string): string | null {
	if (!route.includes('integrations/app-to-app-alexa')) {
		return null;
	}

	return buildAlexaAppLinkingHref(currentQuery);
}
